import { Component, Input, OnInit } from '@angular/core';
import { Attachment } from '../../../models';
import { RmsUtilsService } from '../../../../core/services';

@Component({
    selector: 'rms-text-content-attachments-preview',
    templateUrl: './text-content-attachments-preview.component.html',
    styleUrls: ['./text-content-attachments-preview.component.scss'],
    standalone: false
})
export class TextContentAttachmentsPreviewComponent implements OnInit {

  @Input() attachmentList: Array<Attachment> = [];

  constructor(
    private utilsService: RmsUtilsService
  ) { }

  ngOnInit() {
    this.addAttachmentIcons();
  }

  /**
   * Generates icons per attachment type
   */
  private addAttachmentIcons (): void {
    this.attachmentList.map(item => this.utilsService.setIconType(item));
  }

  /**
   * Deletes an item from the list (from the view)
   * @param index
   */
  public removeItem (index): void {
    this.attachmentList.splice(index, 1);
  }

}
